export const TOGGLE_ALERT = 'TOGGLE_ALERT'
export const SET_OPTIONS = 'SET_OPTIONS'
export const SET_CLOSE_CALLBACK = 'SET_CLOSE_CALLBACK'
export const SET_OPEN_CALLBACK = 'SET_OPEN_CALLBACK'
